import axiosInstance, { ApiKeys, getApiUrl } from '../utils/ApiHelper';
import { GenericObject } from '../types/CommonConstans';
import { FETCH_CHATS_CALLBACK_TYPE, IFetchMoreChatsParams } from '@cp/pages/WhatsappChatbot/types';
import { Dispatch } from '@reduxjs/toolkit';
import { setExtensionVersion } from '@cp/reducers/commonSlice';

type HeartBeatType = {
  heartbeatType: string;
  value: string;
  attributes: GenericObject;
};

const sendHeartBeat = (heartbeats: HeartBeatType[]) => async (dispatch: Dispatch) => {
  const url = getApiUrl(ApiKeys.HEARTBEAT);
  await axiosInstance
    .post(
      url,
      {
        heartbeats: [...heartbeats]
      },
      { headers: { donotHandleError: true, includeInUptimeMetrics: true } }
    )
    .then(res => {
      dispatch(setExtensionVersion(res.data?.ameyoExtensionVersion));
    });
};

export default sendHeartBeat;
